import { showModal } from 'modal.react.js';
import { isNil } from 'ramda';

import { IRoomOption } from 'components/Pages/Admin/Itinerary/Details/RoomsSelect/types';
import Preview from 'components/Pages/Admin/shared/Preview';
import { ISelectOption, TSelectChangeHandler } from 'components/shared/BaseFormComponents/Select/types';
import area from 'components/shared/GlobalModalArea/area';
import Modal from 'components/shared/GlobalModalArea/Modal';
import Slider from 'components/shared/Slider';
import FormTitle from 'components/shared/Typography/FormTitle';

import s from './index.module.css';

export const openPagePreview = (pageId: number) => {
  showModal(area, (res) => (
    <Modal noPadding size="lg" isOpen toClose={res} stopMouseDownPropagation>
      <Preview pageId={pageId} />
    </Modal>
  ));
};

// TODO Refactor type system
export const openRoomPreview = async (
  roomId: number,
  { propertyPage, rooms }: { propertyPage?: ISelectOption; rooms: IRoomOption[] },
) => {
  if (isNil(propertyPage)) return;

  const propertyName = propertyPage.name;
  const roomData = rooms.find(({ value }) => roomId === value);

  if (isNil(roomData)) return;

  await showModal(area, (res) => (
    // TODO make signle modal layout for previews if possible
    <Modal size="auto" isOpen toClose={res} contentClassName={s.modalContent} stopMouseDownPropagation>
      <FormTitle center>{`${propertyName} – ${roomData.label}`}</FormTitle>
      <Slider files={roomData?.media} showLegend />
    </Modal>
  ));
};

export const getNewAttachedPage: TSelectChangeHandler = (name, id, config) => {
  if (id === null && name === null) {
    return undefined;
  }

  return { id, name, isCustom: config?.isCustom } as any;
};

export const getNewDisplaySettings = (accomodationName: string | null | undefined) => {
  const name = accomodationName || '';
  return {
    checkIn: `Check in at ${name}`,
    overnight: `Overnight at ${name}`,
    checkOut: `Check out from ${name}`,
  };
};
